import envVar from '../config/envVars';
import {
  AddSubjectPayload,
  UpdateSubjectPayload
} from '../modules/Subjects/types';
import httpDelete from './httpClient/httpDelete';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';
import httpPut from './httpClient/httpPut';

interface CloneSubjectPayload {
  cloneFrom: {
    grade: string;
    division: string;
  };
  cloneTo: {
    grade: string;
    division: string;
  };
}

const getSubjects = async (school: string, grade: string, division: string) => {
  return httpGet(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/grade/${grade}/division/${division}/subjects`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const addSubject = async (school: string, payload: AddSubjectPayload[]) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/subjects`,
    { subjects: payload },
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const updateSubject = async (
  school: string,
  subjectId: string,
  payload: UpdateSubjectPayload
) => {
  return httpPut(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/subjects/${subjectId}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const cloneSubjects = async (school: string, payload: CloneSubjectPayload) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/subjects/clone`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const deleteSubject = async (school: string, subjectId: string) => {
  return httpDelete(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/subjects/${subjectId}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const fetchSchoolSubject = (school: string, grade: string, division: string) =>
  httpGet(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/grade/${grade}/division/${division}/subjects`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );

const subjectAndGroupingApis = {
  getSubjects,
  addSubject,
  updateSubject,
  deleteSubject,
  cloneSubjects,
  fetchSchoolSubject
};

export default subjectAndGroupingApis;
